import { addDays, differenceInDays } from "date-fns";

export const COMPANY_PAPPERS_SYNC_MIN_DAYS = 30;

export const canSyncCompanyFromPappers = (lastSyncedAt: Date | string | null, now = new Date()): boolean => {
  if (lastSyncedAt === null) {
    return true;
  }

  const lastSyncedAtDate = typeof lastSyncedAt === "string" ? new Date(lastSyncedAt) : lastSyncedAt;
  return differenceInDays(now, lastSyncedAtDate) > COMPANY_PAPPERS_SYNC_MIN_DAYS;
};

export const getNextCompanyPappersSyncDate = (lastSyncedAt: Date | string): Date =>
  addDays(typeof lastSyncedAt === "string" ? new Date(lastSyncedAt) : lastSyncedAt, COMPANY_PAPPERS_SYNC_MIN_DAYS + 1);

export const getDaysUntilCompanyPappersSync = (lastSyncedAt: Date | string, now = new Date()): number => {
  const nextSyncDate = getNextCompanyPappersSyncDate(lastSyncedAt);
  const daysUntil = differenceInDays(nextSyncDate, now);
  return daysUntil > 0 ? daysUntil : 0;
};
